import styled from 'styled-components';
import { Button } from 'antd';

export const BackButtonStyled = styled(Button)`
    &&.ant-btn {
        display: flex;
        align-self: flex-start;
        align-items: center;
        gap: 6px;
        height: auto;
        margin-bottom: 14px;
        padding: 0;
        font-size: 13px;
        color: ${({ theme }) => theme.colors.lightFont};
    }

    &&.ant-btn:not(:disabled):hover {
        color: #4b8cf3;
    }
`;
